import { useState, useEffect } from 'react';

import { HookProps, } from './JitsiMeet.model';
import { JITSI_DOMAIN, JITSI_HOSTNAME } from '../../Helpers/EnvVars';
import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';

declare const window: any;

const useJitsiMeet = ({
  parentNode,
  password,
  subject,
  userInfo,
  onMeetingEnd,
	onParticipantsNrChange,
	organizerId,
  onRecordingStatusChange,
  ...options
}: HookProps) => {
  const [ error, setError ] = useState<null | string>(null);
	const [jitsi, setJitsi] = useState<any>(null);
	
	const { userId } = useAuthenticationDataContext();

  const initialize = async () => {
    const url: string = `${JITSI_DOMAIN}/external_api.js`;
    const loaded = document.querySelector(`script[src="${url}"]`) ;

    if (!loaded) {
      await loadScript(url, true);
    }

    if (jitsi && jitsi.getIFrame()) {
      return;
    }
    
    createMeet(); 
  };

  const loadScript = (url: string, async: boolean = true): Promise<void> => {
    let resolver: any = null;
  
    const onloadPromise = new Promise((resolve) => {
      resolver = resolve;
    });
  
    const script = document.createElement("script");
    script.src = url;
    script.async = async;
    script.onload = () => resolver();

    document.body.appendChild(script);
  
    return onloadPromise as Promise<void>;
  }

  const createMeet = () => {
    if (!window.JitsiMeetExternalAPI) {
      setError(`JitsiMeetExternalAPI is not available, check if ${JITSI_DOMAIN}/external_api.js was loaded`);
      return;
    }

    const parentNodeEl = document.getElementById(parentNode || '');
    
    if (!parentNodeEl) {
      setError(`Parent node is not available, check container have the correct id: "${parentNode}"`);
      return;
    }

    const client = new window.JitsiMeetExternalAPI(JITSI_HOSTNAME, {
      ...options,
      parentNode: parentNodeEl,
      userInfo
    });

    setJitsi(client);

    setError(null);

    subject && client.executeCommand('subject', subject);

    client.addEventListener('recordingStatusChanged', (event: any) => {
      console.log(event, 'recordingStatusChanged');
      const { on } = event;
      onRecordingStatusChange && onRecordingStatusChange({ status: on });
    });

    client.addEventListener('readyToClose', (event: any) => {
			console.log(event, 'readyToClose');
			isOrganizer() && client.executeCommand('stopRecording', 'file');
      onMeetingEnd && onMeetingEnd();
    });

    client.addEventListener('participantJoined', (event: any) => {
      console.log(event, 'participantJoined');
      onParticipantsNrChange && onParticipantsNrChange({ nrOfParticipants: client.getNumberOfParticipants()});
    });

    client.addEventListener('participantLeft', (event: any) => {
			console.log(event, 'participantLeft');
			client.getNumberOfParticipants() ===  1 && client.executeCommand('stopRecording', 'file');
      onParticipantsNrChange && onParticipantsNrChange({ nrOfParticipants: client.getNumberOfParticipants()});
		});
		
		client.addEventListener('videoConferenceLeft', (event: any) => {
			console.log('videoConferenceLeft');
			isOrganizer() && client.executeCommand('stopRecording', 'file');
		});
		
  }

	const destroy = () => {
		isOrganizer() && jitsi?.executeCommand('stopRecording', 'file');
    jitsi?.dispose();
	}
	
	const isOrganizer = () => {
		return userId === organizerId;
	}

  useEffect(() => {
    initialize();
    return () => destroy();
  }, []);

  return { error, jitsi };
}

export default useJitsiMeet;